module.exports = __webpack_public_path__ + "static/media/input_data_template.5c2e0abb.csv";